import script from "./CLanguageButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CLanguageButton.vue?vue&type=script&setup=true&lang=ts"

import "./CLanguageButton.vue?vue&type=style&index=0&id=0f6e7255&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6e7255"]])

export default __exports__